import { combineReducers } from "redux";

import job_type from "../features/admin/career/job_type/Slice";
import location_type from "../features/admin/career/location_type/Slice";
import key_requirements from "../features/admin/career/key_requirements/Slice";
import timetype from "../features/admin/career/timetype/Slice";
import job from "../features/admin/career/job/Slice";
import get_career_inquiry from "../features/admin/career/get_career_inquiry/Slice";

const career = combineReducers({
  job_type,
  location_type,
  key_requirements,
  timetype,
  job,
  get_career_inquiry,
});

export default career;
